import React from 'react';
import { Feature } from './core/enums/features';
import { RouteType } from './core/enums/route-type';
import { BaseRoute } from './core/models/base-routes';

export const routes: BaseRoute[] = [
  {
    path: '/register',
    title: 'Register',
    name: 'create-customer',
    feature: Feature.Landing,
    component: React.lazy(() => import('./create-customer/create-customer')),
    protected: 'Authorize',
  },
  {
    path: '/select-register',
    title: 'Register',
    name: 'select-create-customer',
    feature: Feature.Landing,
    component: React.lazy(() => import('./create-customer/create-customer')),
    protected: 'Authorize',
    type: RouteType.Select,
  },
  {
    path: '/register/:packageCode',
    title: 'Register',
    name: 'create-customer',
    feature: Feature.Landing,
    component: React.lazy(() => import('./create-customer/create-customer')),
    protected: 'Authorize',
  },
  {
    path: '/package-selection',
    title: 'Select Packages',
    name: 'package-list',
    feature: Feature.Landing,
    component: React.lazy(() => import('./package-list/package-list')),
    protected: true,
  },
  {
    path: '/select-package-selection',
    title: 'Select Packages',
    name: 'select-package-list',
    feature: Feature.Landing,
    component: React.lazy(() => import('./package-list/package-list')),
    protected: true,
    type: RouteType.Select,
  },
  {
    path: '/confirm-package',
    title: 'Confirm Package',
    name: 'confirm-package',
    feature: Feature.Landing,
    component: React.lazy(() => import('./confirm-package/confirm-package')),
    protected: false,
  },
  {
    path: '/select-confirm',
    title: 'Confirm Package',
    name: 'select-confirm',
    feature: Feature.Landing,
    component: React.lazy(() => import('./confirm-package/select-confirm')),
    protected: false,
    type: RouteType.Select,
  },
  {
    path: '/select-welcome',
    title: 'Select Welcome',
    name: 'select-welcome',
    feature: Feature.Landing,
    component: React.lazy(() => import('./select/select-welcome/select-welcome')),
    protected: false,
    type: RouteType.Select,
  },
  {
    path: '/confirm-package/:packageCode',
    title: 'Confirm Package',
    name: 'confirm-package',
    feature: Feature.Landing,
    component: React.lazy(() => import('./confirm-package/confirm-package')),
    protected: false,
  },
  {
    path: '/package-add',
    title: 'Add Package',
    name: 'product-detail',
    feature: Feature.Landing,
    component: React.lazy(() => import('./product-detail/product-detail')),
    protected: true,
  },
  {
    path: '/select-add',
    title: 'Add Select Package',
    name: 'select-detail',
    feature: Feature.Landing,
    component: React.lazy(() => import('./flex-product-detail/flex-product-detail')),
    protected: false,
    type: RouteType.Select,
  },
  {
    path: '/payment',
    title: 'Payment',
    name: 'payment',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/make-payment')),
    protected: true,
  },
  {
    path: '/payment-vodacom',
    title: 'Payment',
    name: 'payment',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/vodacom/vodacom-otp/vodacom-otp')),
    protected: true,
  },
  {
    path: '/confirm-vodacom',
    title: 'Payment',
    name: 'payment',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/vodacom/vodacom-details/vodacom-details')),
    protected: true,
  },
  {
    path: '/vodacom-payment-result',
    title: 'Payment',
    name: 'payment',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/vodacom/vodacom-payment-result/vodacom-payment-result')),
    protected: true,
  },
  {
    path: '/select-payment',
    title: 'Payment',
    name: 'select-payment',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/make-payment')),
    protected: true,
    type: RouteType.Select,
  },
  {
    path: '/payment-results',
    title: 'Payment Result',
    name: 'payment-result',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/payment-result/payment-result')),
    protected: true,
  },
  {
    path: '/payment-results/:result',
    title: 'Payment Result',
    name: 'payment-result',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/payment-result/payment-result')),
    protected: true,
  },
  {
    path: '/voucher-fail',
    title: 'Voucher Fail',
    name: 'voucher-fail',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/payment-result/voucher-fail')),
    protected: true,
  },
  {
    path: '/select-payment-results',
    title: 'Payment Result',
    name: 'select-payment-result',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/payment-result/select-payment-result')),
    protected: true,
    type: RouteType.Select,
  },
  {
    path: '/select-payment-results/:result',
    title: 'Payment Result',
    name: 'select-payment-result',
    feature: Feature.Payment,
    component: React.lazy(() => import('./payment/payment-result/select-payment-result')),
    protected: true,
    type: RouteType.Select,
  },
  {
    path: '/package-switch',
    title: 'Switch Package',
    name: 'inactive-package',
    feature: Feature.Landing,
    component: React.lazy(() => import('./inactive-package/inactive-package')),
    protected: true,
  },
  {
    path: '/select-package-switch',
    title: 'Switch Package',
    name: 'select-inactive-package',
    feature: Feature.Landing,
    component: React.lazy(() => import('./inactive-package/inactive-package')),
    protected: true,
    type: RouteType.Select,
  },
  {
    path: '/action',
    title: '',
    name: 'action',
    feature: Feature.Landing,
    component: React.lazy(() => import('./action/action-overlay')),
    protected: false,
  },
  {
    path: '/select-package',
    title: '',
    name: 'select-package',
    feature: Feature.Landing,
    component: React.lazy(() => import('./flex-package-selection/flex-package-selection')),
    protected: false,
    type: RouteType.Select,
  },
  {
    path: '/select-recommended',
    title: 'Recommended Packages',
    name: 'select-recommended',
    feature: Feature.Landing,
    component: React.lazy(() => import('./recommended-packages/recommended-packages')),
    protected: false,
    type: RouteType.Common,
  },
  {
    path: '/capitec-redeem-voucher',
    title: 'Redeem Voucher',
    name: 'capitec-redeem-voucher',
    feature: Feature.Landing,
    component: React.lazy(() => import('./capitec-redeem-voucher/capitec-redeem-voucher')),
    protected: true,
  },
  {
    path: '*',
    title: 'Invalid Page',
    name: 'Page not Found',
    feature: Feature.Landing,
    component: React.lazy(() => import('./page-not-found/page-not-found')),
    protected: false,
  },
];
